import BaseFemaleAvatar from "assets/avatars/iserba/base_female_avatar";
import BaseMaleAvatar from "assets/avatars/iserba/base_male_avatar";

import HaircutFemale1 from "assets/avatars/iserba/haircut_female_1";
import HaircutFemale2 from "assets/avatars/iserba/haircut_female_2";
import HaircutFemale3 from "assets/avatars/iserba/haircut_female_3";
import HaircutFemale4 from "assets/avatars/iserba/haircut_female_4";
import HaircutFemale5 from "assets/avatars/iserba/haircut_female_5";

import MiniHaircutFemale1 from "assets/avatars/iserba/mini_haircut_female_1";
import MiniHaircutFemale2 from "assets/avatars/iserba/mini_haircut_female_2";
import MiniHaircutFemale3 from "assets/avatars/iserba/mini_haircut_female_3";
import MiniHaircutFemale4 from "assets/avatars/iserba/mini_haircut_female_4";
import MiniHaircutFemale5 from "assets/avatars/iserba/mini_haircut_female_5";

import HaircutMale1 from "assets/avatars/iserba/haircut_male_1";
import HaircutMale2 from "assets/avatars/iserba/haircut_male_2";
import HaircutMale3 from "assets/avatars/iserba/haircut_male_3";
import HaircutMale4 from "assets/avatars/iserba/haircut_male_4";
import HaircutMale5 from "assets/avatars/iserba/haircut_male_5";

import MiniHaircutMale1 from "assets/avatars/iserba/mini_haircut_male_1";
import MiniHaircutMale2 from "assets/avatars/iserba/mini_haircut_male_2";
import MiniHaircutMale3 from "assets/avatars/iserba/mini_haircut_male_3";
import MiniHaircutMale4 from "assets/avatars/iserba/mini_haircut_male_4";
import MiniHaircutMale5 from "assets/avatars/iserba/mini_haircut_male_5";

import ClothesCorporateFemale from "assets/avatars/iserba/clothes_corporate_female";
import ClothesExtraCorporateMale from "assets/avatars/iserba/clothes_extra_corporate_male";
import ClothesTechnicianMale from "assets/avatars/iserba/clothes_technician_male";
import ClothesCorporateMalePurple from "assets/avatars/iserba/clothes_corporate_male_purple";
import ClothesCorporateMaleBlue from "assets/avatars/iserba/clothes_corporate_male_blue";
import ClothesExtraCorporateFemale from "assets/avatars/iserba/clothes_extra_corporate_female";
import ClothesCorporateFemaleBlue from "assets/avatars/iserba/clothes_corporate_female_blue";
import ClothesCorporateFemalePurple from "assets/avatars/iserba/clothes_corporate_female_purple";
import ClothesCorporateFemaleTurquoise from "assets/avatars/iserba/clothes_corporate_female_turquoise";
import ClothesTechnicianFemale from "assets/avatars/iserba/clothes_technician_female";
import ClothesCorporateMaleGreyBlack from "assets/avatars/iserba/clothes_corporate_male_grey_black";
import ClothesCorporateMaleTurquoise from "assets/avatars/iserba/clothes_corporate_male_turquoise";
import ClothesCorporateMaleGreyGreen from "assets/avatars/iserba/clothes_corporate_male_grey_green";
import ClothesCorporateFemaleGreyBlack from "assets/avatars/iserba/clothes_corporate_female_grey_black";
import ClothesCorporateFemaleGreyGreen from "assets/avatars/iserba/clothes_corporate_female_grey_green";

/// TODO MAKE SURE EACH SVG HAS DIFFERENT CLASSNAMES AND CLIP PATHS
export const BodySVGs = {
	male: (color) => <BaseMaleAvatar color={color} />,
	female: (color) => <BaseFemaleAvatar color={color} />,
};

export const HairSVGs = {
	male: {
		male1: (color) => <HaircutMale1 color={color} />,
		male2: (color) => <HaircutMale2 color={color} />,
		male3: (color) => <HaircutMale3 color={color} />,
		male4: (color) => <HaircutMale4 color={color} />,
		male5: (color) => <HaircutMale5 color={color} />,
	},
	female: {
		female1: (color) => <HaircutFemale1 color={color} />,
		female2: (color) => <HaircutFemale2 color={color} />,
		female3: (color) => <HaircutFemale3 color={color} />,
		female4: (color) => <HaircutFemale4 color={color} />,
		female5: (color) => <HaircutFemale5 color={color} />,
	},
};

export const MiniHairSVGs = {
	male: {
		male1: (color) => <MiniHaircutMale1 color={color} />,
		male2: (color) => <MiniHaircutMale2 color={color} />,
		male3: (color) => <MiniHaircutMale3 color={color} />,
		male4: (color) => <MiniHaircutMale4 color={color} />,
		male5: (color) => <MiniHaircutMale5 color={color} />,
	},
	female: {
		female1: (color) => <MiniHaircutFemale1 color={color} />,
		female2: (color) => <MiniHaircutFemale2 color={color} />,
		female3: (color) => <MiniHaircutFemale3 color={color} />,
		female4: (color) => <MiniHaircutFemale4 color={color} />,
		female5: (color) => <MiniHaircutFemale5 color={color} />,
	},
};

export const ClothesSVGs = {
	male: {
		maleCorporate: () => <ClothesCorporateMaleTurquoise />,
		maleCorporateBlue: () => <ClothesCorporateMaleBlue />,
		maleCorporateGrey: () => <ClothesCorporateMaleGreyBlack />,
		maleCorporateGreyGreen: () => <ClothesCorporateMaleGreyGreen />,
		maleCorporatePurple: () => <ClothesCorporateMalePurple />,
		maleExtraCorporate: () => <ClothesExtraCorporateMale />,
		// maleEngineer: () => <ClothesEngineerMale />,
		maleThechnician: () => <ClothesTechnicianMale />,
	},
	female: {
		femaleCorporate: () => <ClothesCorporateFemale />,
		femaleCorporateBlue: () => <ClothesCorporateFemaleBlue />,
		femaleCorporateGrey: () => <ClothesCorporateFemaleGreyBlack />,
		femaleCorporateGreyGreen: () => <ClothesCorporateFemaleGreyGreen />,
		femaleCorporatePurple: () => <ClothesCorporateFemalePurple />,
		femaleCorporateTurquoise: () => <ClothesCorporateFemaleTurquoise />,
		femaleExtraCorporate: () => <ClothesExtraCorporateFemale />,
		femaleThechnician: () => <ClothesTechnicianFemale />,
	},
};

export const skinColors = [
	"#FFDFC4",
	"#F0C8A0",
	"#D19C6A",
	"#A36A4C",
	"#8D5524",
	"#5C4033",
];

export const hairColors = [
	"#000000",
	"#4A312C",
	"#8B5A2B",
	"#D15F3F",
	"#F4C27A",
	"#D8D8D8",
];
